import { Organization } from 'src/types/organization/organization';

import api from '../clients/api';

import { AvailableOrganization } from '@/features/shared/api/types/available-organization';
import { OrganizationDevice } from '@/features/shared/api/types/organization-device';
import { OrganizationKiosk } from '@/features/shared/api/types/organization-kiosk';
import { VisitFinishSetting } from '@/features/visits/api/types/visits';

class OrganizationApi {
  async fetchAvailableOrganizations(): Promise<AvailableOrganization[]> {
    const { data } = await api.get('/available-organizations', {
      skipAttachOrganizationToken: true,
      skipAttachSiteToken: true,
    });

    return data;
  }

  async fetchOrganizationDetails(): Promise<Organization> {
    const { data } = await api.get<Organization>('/organization');

    return data;
  }

  async updateDefaultVisitFinishSetting(
    visitFinishSetting: VisitFinishSetting,
  ): Promise<Organization> {
    const { data } = await api.patch<Organization>('/organization/visit-finish-setting', {
      visitFinishSetting,
    });

    return data;
  }

  async updateOrganizationLogo(logoFile: File): Promise<Organization> {
    const formData = new FormData();
    formData.append('logo', logoFile);

    const { data } = await api.patch<Organization>('/organization/logo', formData);

    return data;
  }

  async removeOrganizationLogo(): Promise<Organization> {
    const { data } = await api.delete<Organization>('/organization/logo');

    return data;
  }

  async fetchOrganizationKiosks(): Promise<OrganizationKiosk[]> {
    const { data } = await api.get<OrganizationKiosk[]>('/kiosks');

    return data;
  }

  async fetchOrganizationDevices(): Promise<OrganizationDevice[]> {
    const { data } = await api.get<OrganizationDevice[]>('/organization/devices');

    return data;
  }
}

export const organizationApi = new OrganizationApi();
